// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Doctor — New weekly shift drawer (Stitch) —— */
.doctor-schedule-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 480px !important;
  max-width: calc(100vw - 24px);
}

.doctor-schedule-drawer .ant-drawer-header {
  display: none;
}

.doctor-schedule-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.doctor-schedule-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.doctor-schedule-drawer__header {
  flex-shrink: 0;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.doctor-schedule-drawer__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.doctor-schedule-drawer__title-block {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.doctor-schedule-drawer__title-copy {
  min-width: 0;
}

.doctor-schedule-drawer__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0f172a;
  line-height: 1.3;
}

.doctor-schedule-drawer__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #64748b;
}

.doctor-schedule-drawer__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  flex-shrink: 0;
}

.doctor-schedule-drawer__icon-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
}

[dir='rtl'] .doctor-schedule-drawer__title-block > .doctor-schedule-drawer__icon-btn .anticon {
  transform: scaleX(-1);
}

.doctor-schedule-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
}

.doctor-schedule-drawer__banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #bae6fd;
  background: #f0f9ff;
  color: #0c4a6e;
}

.doctor-schedule-drawer__banner-icon {
  color: #0284c7;
  font-size: 16px;
  margin-top: 1px;
  flex-shrink: 0;
}

.doctor-schedule-drawer__banner-copy {
  min-width: 0;
}

.doctor-schedule-drawer__banner-title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #0369a1;
}

.doctor-schedule-drawer__banner-text {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #075985;
}

.doctor-schedule-drawer__section-label {
  margin: 4px 0 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.doctor-schedule-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.doctor-schedule-drawer__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.doctor-schedule-drawer__req {
  color: #f43f5e;
}

.doctor-schedule-drawer__optional {
  margin-inline-start: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
}

.doctor-schedule-drawer__hint {
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  color: #94a3b8;
}

.doctor-schedule-drawer__control {
  position: relative;
}

.doctor-schedule-drawer__control-icon {
  position: absolute;
  inset-inline-start: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  color: #94a3b8;
  font-size: 15px;
  pointer-events: none;
}

.doctor-schedule-drawer__select.ant-select,
.doctor-schedule-drawer__picker.ant-picker,
.doctor-schedule-drawer__input.ant-input,
.doctor-schedule-drawer__number.ant-input-number {
  width: 100%;
}

.doctor-schedule-drawer__select .ant-select-selector,
.doctor-schedule-drawer__picker.ant-picker,
.doctor-schedule-drawer__input.ant-input,
.doctor-schedule-drawer__number.ant-input-number {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #e2e8f0 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.doctor-schedule-drawer__control .doctor-schedule-drawer__select .ant-select-selector,
.doctor-schedule-drawer__control .doctor-schedule-drawer__picker.ant-picker,
.doctor-schedule-drawer__control .doctor-schedule-drawer__input.ant-input,
.doctor-schedule-drawer__control .doctor-schedule-drawer__number.ant-input-number {
  padding-inline-start: 36px !important;
}

.doctor-schedule-drawer__select .ant-select-selection-item,
.doctor-schedule-drawer__select .ant-select-selection-placeholder,
.doctor-schedule-drawer__picker .ant-picker-input > input,
.doctor-schedule-drawer__input.ant-input {
  font-size: 12px !important;
  font-weight: 500;
  line-height: 34px !important;
  color: #0f172a;
}

.doctor-schedule-drawer__number .ant-input-number-input {
  height: 34px !important;
  font-size: 12px !important;
  font-weight: 500;
  color: #0f172a;
}

.doctor-schedule-drawer__select.ant-select-focused .ant-select-selector,
.doctor-schedule-drawer__picker.ant-picker-focused,
.doctor-schedule-drawer__input.ant-input:focus,
.doctor-schedule-drawer__number.ant-input-number-focused {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.doctor-schedule-drawer__picker .ant-picker-suffix {
  color: transparent;
}

.doctor-schedule-drawer__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

@media (max-width: 520px) {
  .doctor-schedule-drawer__row {
    grid-template-columns: 1fr;
  }
}

.doctor-schedule-drawer__duration {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #bae6fd;
  background: #f0f9ff;
  font-size: 12px;
  font-weight: 500;
  color: #0369a1;
}

.doctor-schedule-drawer__duration-icon {
  color: #0284c7;
  font-size: 15px;
  flex-shrink: 0;
}

.doctor-schedule-drawer__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.doctor-schedule-drawer__toggle-copy {
  min-width: 0;
}

.doctor-schedule-drawer__toggle-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.doctor-schedule-drawer__toggle-hint {
  margin: 2px 0 0;
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
}

.doctor-schedule-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.doctor-schedule-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.doctor-schedule-drawer__btn--ghost {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
}

.doctor-schedule-drawer__btn--ghost:hover {
  background: #f8fafc;
  color: #0f172a;
}

.doctor-schedule-drawer__btn--primary {
  border: 0;
  background: #0ea5e9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.doctor-schedule-drawer__btn--primary:hover:not(:disabled) {
  background: #0284c7;
}

.doctor-schedule-drawer__btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.doctor-schedule-drawer .ant-form-item {
  margin-bottom: 0 !important;
}

.doctor-schedule-drawer .ant-form-item-explain-error {
  font-size: 11px;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowDoctor/components/drawers/DoctorScheduleDrawer.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;;;;EAIE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* —— Doctor — New weekly shift drawer (Stitch) —— */\n.doctor-schedule-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 480px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.doctor-schedule-drawer .ant-drawer-header {\n  display: none;\n}\n\n.doctor-schedule-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.doctor-schedule-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.doctor-schedule-drawer__header {\n  flex-shrink: 0;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.doctor-schedule-drawer__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.doctor-schedule-drawer__title-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.doctor-schedule-drawer__title-copy {\n  min-width: 0;\n}\n\n.doctor-schedule-drawer__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n  line-height: 1.3;\n}\n\n.doctor-schedule-drawer__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.doctor-schedule-drawer__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.doctor-schedule-drawer__icon-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n[dir='rtl'] .doctor-schedule-drawer__title-block > .doctor-schedule-drawer__icon-btn .anticon {\n  transform: scaleX(-1);\n}\n\n.doctor-schedule-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n}\n\n.doctor-schedule-drawer__banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #bae6fd;\n  background: #f0f9ff;\n  color: #0c4a6e;\n}\n\n.doctor-schedule-drawer__banner-icon {\n  color: #0284c7;\n  font-size: 16px;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.doctor-schedule-drawer__banner-copy {\n  min-width: 0;\n}\n\n.doctor-schedule-drawer__banner-title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  color: #0369a1;\n}\n\n.doctor-schedule-drawer__banner-text {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #075985;\n}\n\n.doctor-schedule-drawer__section-label {\n  margin: 4px 0 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.doctor-schedule-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.doctor-schedule-drawer__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.doctor-schedule-drawer__req {\n  color: #f43f5e;\n}\n\n.doctor-schedule-drawer__optional {\n  margin-inline-start: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.doctor-schedule-drawer__hint {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #94a3b8;\n}\n\n.doctor-schedule-drawer__control {\n  position: relative;\n}\n\n.doctor-schedule-drawer__control-icon {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  color: #94a3b8;\n  font-size: 15px;\n  pointer-events: none;\n}\n\n.doctor-schedule-drawer__select.ant-select,\n.doctor-schedule-drawer__picker.ant-picker,\n.doctor-schedule-drawer__input.ant-input,\n.doctor-schedule-drawer__number.ant-input-number {\n  width: 100%;\n}\n\n.doctor-schedule-drawer__select .ant-select-selector,\n.doctor-schedule-drawer__picker.ant-picker,\n.doctor-schedule-drawer__input.ant-input,\n.doctor-schedule-drawer__number.ant-input-number {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #e2e8f0 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.doctor-schedule-drawer__control .doctor-schedule-drawer__select .ant-select-selector,\n.doctor-schedule-drawer__control .doctor-schedule-drawer__picker.ant-picker,\n.doctor-schedule-drawer__control .doctor-schedule-drawer__input.ant-input,\n.doctor-schedule-drawer__control .doctor-schedule-drawer__number.ant-input-number {\n  padding-inline-start: 36px !important;\n}\n\n.doctor-schedule-drawer__select .ant-select-selection-item,\n.doctor-schedule-drawer__select .ant-select-selection-placeholder,\n.doctor-schedule-drawer__picker .ant-picker-input > input,\n.doctor-schedule-drawer__input.ant-input {\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 34px !important;\n  color: #0f172a;\n}\n\n.doctor-schedule-drawer__number .ant-input-number-input {\n  height: 34px !important;\n  font-size: 12px !important;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.doctor-schedule-drawer__select.ant-select-focused .ant-select-selector,\n.doctor-schedule-drawer__picker.ant-picker-focused,\n.doctor-schedule-drawer__input.ant-input:focus,\n.doctor-schedule-drawer__number.ant-input-number-focused {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.doctor-schedule-drawer__picker .ant-picker-suffix {\n  color: transparent;\n}\n\n.doctor-schedule-drawer__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n@media (max-width: 520px) {\n  .doctor-schedule-drawer__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.doctor-schedule-drawer__duration {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #bae6fd;\n  background: #f0f9ff;\n  font-size: 12px;\n  font-weight: 500;\n  color: #0369a1;\n}\n\n.doctor-schedule-drawer__duration-icon {\n  color: #0284c7;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.doctor-schedule-drawer__toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.doctor-schedule-drawer__toggle-copy {\n  min-width: 0;\n}\n\n.doctor-schedule-drawer__toggle-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.doctor-schedule-drawer__toggle-hint {\n  margin: 2px 0 0;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.doctor-schedule-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.doctor-schedule-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.doctor-schedule-drawer__btn--ghost {\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.doctor-schedule-drawer__btn--ghost:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.doctor-schedule-drawer__btn--primary {\n  border: 0;\n  background: #0ea5e9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.doctor-schedule-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284c7;\n}\n\n.doctor-schedule-drawer__btn--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.doctor-schedule-drawer .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.doctor-schedule-drawer .ant-form-item-explain-error {\n  font-size: 11px;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
